// Shared back-navigation stack. Any overlay/modal/sheet that should close on
// the phone's back button (Android hardware/gesture back, via @capacitor/app's
// `backButton` event - wired up once in CustomerDashboard) pushes a close
// handler while it's open and pops it on close. The backButton listener always
// consumes the topmost handler first, so nested overlays unwind one at a time
// instead of the whole app exiting from under whatever happens to be open.
type Handler = () => void;
const stack: Handler[] = [];

export function pushBackHandler(handler: Handler): () => void {
  stack.push(handler);
  return () => {
    const i = stack.indexOf(handler);
    if (i !== -1) stack.splice(i, 1);
  };
}

// Returns true if something was closed (caller should stop there); false if
// the stack was empty (caller should fall through to its own default, e.g.
// tab-to-home then minimize).
export function consumeBack(): boolean {
  const handler = stack.pop();
  if (handler) {
    handler();
    return true;
  }
  return false;
}
